// extracted by mini-css-extract-plugin
export default {"tagProductListContainer":"TagProductList_tagProductListContainer__eb+Jx","loadingBox":"TagProductList_loadingBox__k5P2j"};